/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Settings_Template_Audience_Whole_TrackInputs */



/**
* | output |
* | --- |
* | "Everyone in {title}" |
*
* @param {Settings_Template_Audience_Whole_TrackInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_audience_whole_track = /** @type {((inputs: Settings_Template_Audience_Whole_TrackInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Audience_Whole_TrackInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Iedereen in ${i?.title}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tout le monde dans ${i?.title}`)
	return /** @type {LocalizedString} */ (`Everyone in ${i?.title}`)
});